export default __webpack_public_path__ + "static/media/Protein.ae05b258.jpg";